module.exports = __webpack_public_path__ + "img/menu-off_01.4217aa7d.png";